import { TranslateService } from '@ngx-translate/core';
import { CellType, ColumnConfig } from '@shared/table';
import { FlowsLocalizationCellComponent } from './flows-localization-cell/flows-localization-cell.component';
import { FlowContentItemTable, ReviewRequired, ReviewRequiredOption, SortByUpdate, SortByUpdateOption } from './flows-localization.abstraction';
import { BotLanguage } from '@core/languages';

export class FlowsLocalizationUtility {
  static getColumnsConfig(supportedLocales: BotLanguage[]): ColumnConfig<FlowContentItemTable>[] {
    return supportedLocales
      .sort((item) => (item.isDefault ? -1 : 1))
      .map((item) => ({
        name: `${item.id}`,
        header: item.isDefault ? `Main [${item.code.toLocaleUpperCase()}]` : `Additional [${item.code.toLocaleUpperCase()}]`,
        cellType: CellType.Custom,
        withColumnNameProp: true,
        customCell: { component: FlowsLocalizationCellComponent },
      }));
  }

  static getReviewRequiredOptions(translateService: TranslateService): ReviewRequiredOption[] {
    return [
      {
        value: null,
        label: translateService.instant('flowsLocalizationPage.filter.placeholder'),
      },
      {
        value: ReviewRequired.required,
        label: translateService.instant('flowsLocalizationPage.filter.option.reviewRequired'),
      },
      {
        value: ReviewRequired.notRequired,
        label: translateService.instant('flowsLocalizationPage.filter.option.reviewNotRequired'),
      },
    ];
  }

  static getSortByUpdateOptions(translateService: TranslateService): SortByUpdateOption[] {
    return [
      {
        value: SortByUpdate.null,
        label: translateService.instant('flowsLocalizationPage.sort.placeholder'),
      },
      {
        value: SortByUpdate.newestFirst,
        label: translateService.instant('flowsLocalizationPage.sort.option.newestFirst'),
      },
      {
        value: SortByUpdate.oldestFirst,
        label: translateService.instant('flowsLocalizationPage.sort.option.oldestFirst'),
      },
    ];
  }
}
